/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { Menu, Avatar} from "antd";
import { UserOutlined,LoginOutlined, AlignLeftOutlined } from "@ant-design/icons";
import { useTranslation } from 'react-i18next';
import { GetLoginRedirect, logout } from 'api/hub'
import { connect, useDispatch, useSelector } from 'react-redux'

const RightMenu = ({ mode }) => {
//   localStorage.setItem("LoginInfo",JSON.stringify({
//     "accessToken": "eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICIxTDFoeUxnZDBrSlhPZEdVMldVaGZmWE9XRktBcmFXTUxEa3hhTFl3cEVjIn0.eyJleHAiOjE2NjcyMTA4ODYsImlhdCI6MTY2NzIwNzI4NiwiYXV0aF90aW1lIjoxNjY3MjA2MzAwLCJqdGkiOiJmZTZiY2M0Ny1lMTg4LTRjNzAtYmZlMy04M2RiMTFmZDgyYTIiLCJpc3MiOiJodHRwczovL2F1dGhjZW50ZXJzdC53aWFkdmFuY2UuY29tL2F1dGgvcmVhbG1zL3Zhc3Rlc3QiLCJhdWQiOiJhY2NvdW50Iiwic3ViIjoiNWQ1YjljYTgtZDJkYi00YTMyLWFjNDMtZWE4ZDNlZTYxMGQxIiwidHlwIjoiQmVhcmVyIiwiYXpwIjoiYXBwbWFya2V0Iiwic2Vzc2lvbl9zdGF0ZSI6ImViNmI2NWNkLTUyYzMtNDA1NC04M2Q0LTA5OWU3ODQxOTc3NSIsImFjciI6IjAiLCJyZWFsbV9hY2Nlc3MiOnsicm9sZXMiOlsiU1VCMjAyMjEwMjYwMDAwMDQiLCJTVUIyMDIyMTAyNjAwMDAxNSIsIlNVQjIwMjIxMDI2MDAwMDE0IiwiU1VCMjAyMjEwMjYwMDAwMTMiLCJTVUIyMDIyMTAyNzAwMDAwMSIsIlNVQjIwMjIxMDI2MDAwMDE5IiwiU1VCMjAyMjEwMjcwMDAwMDMiLCJTVUIyMDIyMTAyNzAwMDAwMiIsIlNVQjIwMjIxMDI1MDAwMDA4Iiwib2ZmbGluZV9hY2Nlc3MiLCJTVUIyMDIyMTAyNTAwMDAwNiIsIlNVQjIwMjIxMDI1MDAwMDA3IiwiU1VCMjAyMjEwMjUwMDAwMDUiLCJ1bWFfYXV0aG9yaXphdGlvbiJdfSwicmVzb3VyY2VfYWNjZXNzIjp7ImFjY291bnQiOnsicm9sZXMiOlsibWFuYWdlLWFjY291bnQiLCJtYW5hZ2UtYWNjb3VudC1saW5rcyIsInZpZXctcHJvZmlsZSJdfX0sInNjb3BlIjoiY29tbXVuaWNhdGlvbiBhY2Nlc3NfdG9rZW4gcHJvZmlsZSBlbWFpbCBjbGllbnRfYWNjZXNzX3Rva2VuIiwiZW1haWxfdmVyaWZpZWQiOmZhbHNlLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJhbGV4LmxvQHdpYWR2YW5jZS5jb20iLCJlbWFpbCI6ImFsZXgubG9Ad2lhZHZhbmNlLmNvbSJ9.a82eNA4GPI7Z9kdXkCGq2KMDsi_Q3F2DUhWpCJryZUiLm-xqPLd5-GewJROtzaLPnyb0XNdSat0JQYs01RsHyzBGBn7U3bdN3vsCj8IcivCwuh5fmIdmq5pQnEXL93sZO7PTS_EfMKLp2CW7uP_v-irj4TA_Mwks1NTBkJPDZ_6Csyrp8I-kBoilv4XkmvrWoaos3PEUSowv7Mc-4hMHN5n-BtswUR_NRBG_JmAu_SYE7go6lbWncJr-3nDbrC8PSGoqK9SP02Xf6WV2u4TDXmnjDPnIBNwMif1shjXp_tp0NqwZJl1qTQZJIEM5mB3fc6Rf-rgrgbPL1nVCLJHR8A",
//     "loginType": "WiAdvance App Market",
//     "tenantId": "T0050170419814207488",
//     "tenantName": "SaaS Service股份有限公司",
//     "tenantNameen": "SaaS Service Co., Ltd.",
//     "userName": "Alex",
//     "account": "alex.lo@wiadvance.com",
//     "operator_id": "W0061654297531781121",
//     "isAuthenticated": true,
//     "profilePhoto": null,
//     "userType": 1,
//     "accountType": "user"
// }))
  const dispatch = useDispatch()
  const { i18n, t } = useTranslation()
  const [loading, setLoading] = useState(false)
  // const LoginInfo = JSON.parse(localStorage.getItem('LoginInfo'))
  const LoginInfo = null
  useEffect(()=>{
    if(localStorage.getItem('lang') === null){
      var lang = navigator.language || navigator.userLanguage;
      if(lang ==='zh-TW' || lang ==='zh-CN' || lang === 'zh-HK'){
        lang='tw'
      }else{
        lang='en'
      }
      localStorage.setItem('lang',lang)
    } else {
      i18n.changeLanguage(localStorage.getItem('lang'))
    }
  }, [])

  const handleLogin = () => {
    console.log(process.env.REACT_APP_ENV)
    setLoading(true)
    if(process.env.REACT_APP_ENV === "local"){
      dispatch(GetLoginRedirect({request:'http://localhost:3000/auth/login'})).then(res=>{
        setLoading(false)
        if(res){
          if(res.code === 200) {
            window.location.href=res.data
          }
        }
        })
      }else{
        dispatch(GetLoginRedirect()).then(res=>{
          setLoading(false)
          if(res){
            if(res.code === 200) {
              window.location.href=res.data
            }
          }
          })
      }
  }

  const handleLangChange = () => {
    var value = (localStorage.getItem('lang')? localStorage.getItem('lang'): i18n.language) === 'tw'?"en":"tw"
    // console.log(value)
    if (value && value !== null) {
      localStorage.setItem('lang',value)
      i18n.changeLanguage(value)
    }
  }

  const handleLogout = () => {
    setLoading(true)
    dispatch(logout({
      "access_token": LoginInfo.accessToken
    })).then(res=>{
      setLoading(false)
      console.log(res)
 
      localStorage.removeItem('LoginInfo')
      localStorage.removeItem('refresh_token')
      window.location.href='/'
      
    })
  
  }

  const menuprofile = () => {
    if(LoginInfo){
      if(LoginInfo.profilePhoto) {
        return (
          <>
          <div style={{"display":"flex"}}>
          <div>
          <img style={{height:"35px", width:"35px", borderRadius:"50%"}} src={LoginInfo.profilePhoto}/>
          </div>
          <span className="username" style={{fontSize:"16px", fontWeight:"400"}}>{LoginInfo.userName}</span>
          </div>
          </>
        )
      } else {
        return (
          <>
          <Avatar icon={<UserOutlined />} />
          <span style={{fontSize:"16px", fontWeight:"400"}} className="username">
            {LoginInfo.userName}
          </span>
        </>
        )
      }
    } else {
      return (
        <>
            <Avatar icon={<UserOutlined />} />
            <span style={{fontSize:"16px", fontWeight:"400"}} className="username">
              Guest
            </span>
          </>
      )
    }
  }

  return (
    <Menu mode={mode}>
      <Menu.Item key="lang" style={{ borderTop:"solid 1px #7d7d7d30"}}>
          <a onClick={handleLangChange} style={{fontSize:"16px", fontWeight:"400"}}>
          <AlignLeftOutlined /> {
          (localStorage.getItem('lang')? localStorage.getItem('lang'): i18n.language) === 'tw'?"English":"中文"
          }
          </a>
        </Menu.Item>
      <Menu.SubMenu
        title={
          menuprofile()
        }
      >
        {/* {
        LoginInfo == null ?
        <>
        <Menu.Item key="login">
          <a onClick={handleLogin} style={{fontSize:"16px", fontWeight:"400"}}>
          <LoginOutlined /> {t('Header.login')}
          </a>
        </Menu.Item>
        <Menu.Item key="sign_up">
          <a href="/Register/Agreement" style={{fontSize:"16px", fontWeight:"400"}}>
          <UserOutlined /> {t('Header.sign_up')}
          </a>
        </Menu.Item>
        <Menu.Item key="2" style={{fontSize:"16px", fontWeight:"400"}}>
        <a rel="noopener noreferrer" href="/ResendLetter">
          {t('Header.ReSend')}
        </a>
      </Menu.Item> 
        <Menu.Item key="lang" style={{ borderTop:"solid 1px #7d7d7d30"}}>
          <a onClick={handleLangChange} style={{fontSize:"16px", fontWeight:"400"}}>
          <AlignLeftOutlined /> {
          (localStorage.getItem('lang')? localStorage.getItem('lang'): i18n.language) === 'tw'?"English":"中文"
          }
          </a>
        </Menu.Item>
        </>:
        <>
        <Menu.Item key="0">
        <a style={{fontSize:"16px", fontWeight:"400"}} rel="noopener noreferrer" href="/portal/service">
          {t('Header.MemberCenter')}
        </a>
      </Menu.Item>
      <Menu.Item key="1">
        <a style={{fontSize:"16px", fontWeight:"400"}} rel="noopener noreferrer" href="/portal/account/setting/user">
          {t('Header.MyAccount')}
        </a>
      </Menu.Item>
      <Menu.Item key="4">
        <a style={{fontSize:"16px", fontWeight:"400"}} rel="noopener noreferrer" href="/portal/account/password">
          {t('Header.ChangePassword')}
        </a>
      </Menu.Item> 
      <Menu.Divider />
      <Menu.Item key="4" >
        <a style={{fontSize:"16px", fontWeight:"400"}} rel="noopener noreferrer" onClick={handleLogout}>
        {t('Header.SignOut')}
        </a>
      </Menu.Item>
        </>
    } */}
      </Menu.SubMenu>
    </Menu>
  );
};

export default RightMenu;